import EmojiPicker, { type EmojiClickData } from 'emoji-picker-react';
import de from 'emoji-picker-react/dist/data/emojis-de';
import IconComponent from 'gcs-common/components/Icon/Icon';
import { ICON, ICON_COLOR } from 'gcs-common/constants/IconConstants';
import useOnClickOutside from 'gcs-common/hooks/useOnClickOutside';
import { getSelectedChannelId } from 'gcs-common/slices/channels/channelsSelectors';
import { changeInputText } from 'gcs-common/slices/messageInput/messageInputThunks/changeInputText';
import { useCallback, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './styles.module.scss';

const SmileyMessageInput = () => {
  const emojiPickerRef = useRef(null);
  const [emojiShown, setEmojiShown] = useState(false);

  const selectedChannelId = useSelector(getSelectedChannelId);
  const dispatch = useDispatch();

  const onEmojiPicked = useCallback(
    (obj: EmojiClickData) => {
      const inputText = `${obj.emoji}`;
      dispatch(
        changeInputText({
          channelId: selectedChannelId,
          inputText,
          append: true,
        }),
      );
    },
    [dispatch, selectedChannelId],
  );

  useOnClickOutside(emojiPickerRef, () => setEmojiShown(false));

  return (
    <div className={styles.mediaInputWrapper}>
      <button type="button" id="show-emoji-no" className={styles.smileyInputIcon} onClick={() => setEmojiShown(true)}>
        <IconComponent Icon={ICON.EMOJI} color={ICON_COLOR.LIGHT_GREY} />
      </button>
      {emojiShown && (
        <div className={styles.emojiTable} ref={emojiPickerRef}>
          <EmojiPicker onEmojiClick={onEmojiPicked} emojiData={de} lazyLoadEmojis />
        </div>
      )}
    </div>
  );
};

export default SmileyMessageInput;
